import { forgotPassword } from "./forgot-password.service";

export const forgotPasswordService = { forgotPassword };
